module.exports = __webpack_public_path__ + "1.0.0-d5234419/img/offline-vault-1.42857efb.svg";